module.exports = __webpack_public_path__ + "img/linux.0dd8a144.png";